/* eslint-disable no-unused-vars, no-console, react/jsx-indent-props,react/jsx-wrap-multilines, no-undef, react/jsx-closing-bracket-location */

import React from "react";
import get from "lodash/get";
import { WithPreview, InfiniteStoryBase } from "@quintype/components";
import { number, object, shape, array, string } from "prop-types";

import BlankStory from "../story-templates/blank";
import LiveBlogStory from "../story-templates/live-blog";
import VideoStory from "../story-templates/video";
import PhotoStory from "../story-templates/photo";
import HoroscopeStory from "../story-templates/horoscope";
import EventsStory from "../story-templates/events";

export function StoryPageBase(
  { story, recentStories, trendingStories, params, collectionName, preview = false },
  config
) {
  if (story["story-template"] === "live-blog") {
    return (
      <LiveBlogStory
        story={story}
        recentStories={recentStories}
        trendingStories={trendingStories}
        collectionName={collectionName}
        cardId={get(params, ["cardId"])}
        config={config}
      />
    );
  } else if (story["story-template"] === "video") {
    return (
      <VideoStory
        story={story}
        recentStories={recentStories}
        trendingStories={trendingStories}
        preview={preview}
        config={config}
        collectionName={collectionName}
      />
    );
  } else if (story["story-template"] === "photo") {
    return (
      <PhotoStory
        story={story}
        recentStories={recentStories}
        trendingStories={trendingStories}
        preview={preview}
        config={config}
        collectionName={collectionName}
      />
    );
  } else if (story["story-template"] === "horoscope") {
    return (
      <HoroscopeStory
        story={story}
        recentStories={recentStories}
        trendingStories={trendingStories}
        collectionName={collectionName}
        cardId={get(params, ["cardId"])}
        preview={preview}
        config={config}
      />
    );
  } else if (story["story-template"] === "events") {
    return (
      <EventsStory
        story={story}
        recentStories={recentStories}
        trendingStories={trendingStories}
        preview={preview}
        config={config}
      />
    );
  } else {
    return (
      <BlankStory
        story={story}
        recentStories={recentStories}
        trendingStories={trendingStories}
        config={config}
        preview={preview}
        collectionName={collectionName}
      />
    );
  }
}

StoryPageBase.propTypes = {
  index: number,
  story: object,
  recentStories: array,
  trendingStories: array,
  collectionName: string,
  config: object
};

const FIELDS =
  // eslint-disable-next-line max-len
  "id,headline,slug,url,hero-image-s3-key,hero-image-metadata,authors,first-published-at,metadata,tags,last-published-at,alternative,published-at,author-name,author-id,sections,story-template,cards";
function storyPageLoadItems(pageNumber, recentStories, collectionName, trendingStories, story) {
  switch (pageNumber) {
    case 0:
      return Promise.resolve();
    // return global
    //   .wretch(`/api/v1/stories/${story.id}/related-stories`)
    //   .query({
    //     fields: FIELDS,
    //     limit: 5,
    //     offset: 5 * pageNumber,
    //     "section-id": get(story, ["sections", 0, "id"])
    //   })
    //   .get()
    //   .json(response => {
    //     if (response && response["related-stories"]) {
    //       return response["related-stories"].map(story => ({
    //         story,
    //         recentStories,
    //         collectionName,
    //         trendingStories
    //       }));
    //     }
    //   });
    default:
      return Promise.resolve();
    // return global
    //   .wretch("/api/v1/stories")
    //   .query({
    //     fields: FIELDS,
    //     limit: 5,
    //     offset: 5 * pageNumber,
    //     "section-id": get(story, ["sections", 0, "id"])
    //   })
    //   .get()
    //   .json(response => response.stories.map(story => ({ story, recentStories, trendingStories, collectionName })));
  }
}

export function StoryPage(props) {
  return (
    <InfiniteStoryBase
      {...props}
      render={storyProps => StoryPageBase(storyProps, props.config)}
      loadItems={pageNumber =>
        storyPageLoadItems(
          pageNumber,
          props.data.recentStories,
          props.data.collectionName,
          props.data.trendingStories,
          props.data.story
        )
      }
      onInitialItemFocus={item =>
        app.registerPageView({ pageType: "story-page", data: { story: item.story } }, `/${item.story.slug}`)
      }

      // onItemFocus={(item, index) => {
      //   if (index < 1) {
      //     _taboola.push({
      //       mode: "thumbnails-b",
      //       container: `${item.story.slug}`,
      //       placement: "Below Article Thumbnails 2nd",
      //       target_type: "mix"
      //     });

      //     _taboola.push({ article: "auto", url: item.story.url });
      //     _taboola.push({ flush: true });
      //   }
      // }}
    />
  );
}

StoryPage.propTypes = {
  data: shape({
    story: object
  }),
  config: object
};

export const StoryPagePreview = WithPreview(StoryPage, (data, story) =>
  Object.assign({}, data, {
    story,
    trendingStories: Array(5).fill(story)
  })
);
